import axios from "axios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const getTodaySpecial = async () => {
  try {
    const response = await axios.get(`${API_URL}/get.php`);
    return response.data;
  } catch (error) {
    console.error("Error fetching special numbers:", error);
    throw error;
  }
};

export const getFreeNumbers  = async () => {
  try {
    const response = await axios.get(`${API_URL}/getfreenumbers.php`);
    return response.data;
  } catch (error) {
    console.error("Error fetching special numbers:", error);
    throw error;
  }
};

export const getLandlineNumbers = async () => {
  try {
    const response = await axios.get(`${API_URL}/getlandline.php`);
    return response.data;
  } catch (error) {
    console.error("Error fetching special numbers:", error);
    throw error;
  }
};

export const getDiscountNumbers = async () => {
  try {
    const response = await axios.get(`${API_URL}/getdiscount.php`);
    return response.data;
  } catch (error) {
    console.error("Error fetching discount numbers:", error);
    throw error;
  }
};

export const getAllNumbers = async () => {
  try {
    const response = await axios.get(`${API_URL}/getallnumbers.php`);
    return response.data;
  } catch (error) {
    console.error("Error fetching special numbers:", error);
    throw error;
  }
};

export const getSoldNumbers = async () => {
  try {
    const response = await axios.get(`${API_URL}/getsoldnumbers.php`);
    return response.data;
  } catch (error) {
    console.error("Error fetching special numbers:", error);
    throw error;
  }
};

export const getNumbersByPrice = async (price) => {
  try {
    const response = await axios.get(`${API_URL}/get_by_price.php?price=${price}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching numbers for price ${price}:`, error);
    throw error;
  }
};

